import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import Root from '@/layout/root.vue'

const routes = [
  {
      path: '/',
      name: 'Welcome',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'Welcome',
          component: () => import('@/views/welcome.vue'),
          meta: {
            title: '欢迎页',
          }
        },
        {
          path: '/welcome',
          redirect: '/',
        },
      ]
  },
  {
    path: '/micro-app',   // history模式需要通配所有路由，详见vue-router文档
    name: 'MicroApp',
    meta: {},
    component: Layout,
    children: [
      {
        path: 'analysis-plan',
        name: 'AnalysisPlan',
        component: () => import('@/views/projectCenter/task/analysisPlan.vue'),
        meta: {
          title: '生信分析信息填写',
          keepAlive: false
        },
      }
    ]
  },
  {
    path: '/project-center',
    name: 'ProjectCenter',
    component: Layout,
    meta: {
      title: '项目中心',
      keepAlive: false
    },
    children: [
      {
        path: 'iframe',
        name: 'IframeView',
        component: () => import('@/views/iframeView/index.vue'),
        meta: {
          title: 'iframe',
          keepAlive: false
        }
      },
      {
        path: 'download',
        name: 'Download',
        component: () => import('@/views/projectCenter/common/download.vue'),
        meta: {
          title: '美吉网盘下载',
          keepAlive: false,
          siderBar: false
        }
      },
      {
        path: 'middlePage',
        name: 'MiddlePage',
        component: () => import('@/views/projectCenter/common/middlePage.vue'),
        meta: {
          title: '中间页',
          keepAlive: false
        }
      },
      {
        path: 'overview',
        name: 'Overview',
        component: () => import('@/views/projectCenter/overview/index.vue'),
        meta: {
          title: '项目中心 - 概览',
          keepAlive: false,
          activeMenu: '1',
        }
      },
      {
        path: 'task',
        name: 'Task',
        component: () => import('@/views/projectCenter/task/index.vue'),
        meta: {
          title: '项目中心 - 我的事项',
          keepAlive: false,
          activeMenu: '2',
        }
      },
      {
        path: 'task-report',
        name: 'TaskReport',
        component: () => import('@/views/projectCenter/task/report.vue'),
        meta: {
          title: '查看报告',
          keepAlive: false,
          activeMenu: '2',
        }
      },
      {
        path: 'comfirm-report',
        name: 'ComfirmReport',
        component: () => import('@/views/projectCenter/task/comfirmReport.vue'),
        meta: {
          title: '确认报告',
          keepAlive: false,
          activeMenu: '2',
        }
      },
      {
        path: 'contract-info-detail',
        name: 'ContractInfoDetail',
        component: () => import('@/views/projectCenter/task/contractInfoDetail.vue'),
        meta: {
          title: ' 合同立项信息确认',
          keepAlive: false,
          activeMenu: '2',
        }
      },
      {
        path: 'raw-data-detail',
        name: 'RawDataDetail',
        component: () => import('@/views/projectCenter/task/rawDataDetail.vue'),
        meta: {
          title: ' 原始数据确认',
          keepAlive: false,
          activeMenu: '2',
        }
      },
      {
        path: 'contract',
        name: 'Contract',
        component: () => import('@/views/projectCenter/contract/index.vue'),
        meta: {
          title: '项目中心 - 我的合同',
          keepAlive: false
        }
      },
      {
        path: 'contract-detail',
        name: 'ContractDetail',
        component: () => import('@/views/projectCenter/contract/detail.vue'),
        meta: {
          title: '合同详情',
          keepAlive: false,
          activeMenu: '3',
        }
      },
      {
        path: 'send-order',
        name: 'SendOrder',
        component: () => import('@/views/projectCenter/sendOrder/index.vue'),
        meta: {
          title: '项目中心 - 订单列表',
          keepAlive: false
        }
      },
      {
        path: 'send-order-detail',
        name: 'SendOrderDetail',
        component: () => import('@/views/projectCenter/sendOrder/detail.vue'),
        meta: {
          title: '订单详情',
          keepAlive: false,
          activeMenu: '4',
        }
      },
      {
        path: 'report',
        name: 'MyReport',
        component: Root,
        meta: {
          title: '我的分析报告',
          keepAlive: false
        },
        children: [
          // {
          //   path: 'project-overview',
          //   name: 'ProjectOverviewIframe',
          //   component: () => import('@/views/projectCenter/projectOverview/iframe.vue'),
          //   meta: {
          //     title: '项目中心 - 项目总览',
          //     keepAlive: false
          //   }
          // },
          {
            path: 'project-overview',
            name: 'ProjectOverview',
            component: () => import('@/views/projectCenter/projectOverview/index.vue'),
            meta: {
              title: '项目中心 - 项目总览',
              keepAlive: false
            }
          },
          {
            path: 'project-overview-detail',
            name: 'ProjectOverviewDetail',
            component: () => import('@/views/projectCenter/projectOverview/details.vue'),
            meta: {
              title: '项目中心 - 项目总览详情',
              keepAlive: false
            }
          },
          // {
          //   path: 'task',
          //   name: 'ReportTask',
          //   component: () => import('@/views/projectCenter/report/task/iframe.vue'),
          //   meta: {
          //     title: '项目中心 - 任务总览',
          //     keepAlive: false
          //   }
          // },
          {
            path: 'task',
            name: 'ReportTask',
            component: () => import('@/views/projectCenter/report/task/index.vue'),
            meta: {
              title: '项目中心 - 任务总览',
              keepAlive: false
            }
          },
          {
            path: 'recycle',
            name: 'RecycleReport',
            component: () => import('@/views/projectCenter/report/recycle/index.vue'),
            meta: {
              title: '项目中心 - 回收站',
              keepAlive: false
            }
          },
          {
            path: 'offline',
            name: 'OfflineReport',
            component: () => import('@/views/projectCenter/report/offline/index.vue'),
            meta: {
              title: '项目中心 - 线下报告',
              keepAlive: false
            }
          },
        ],
      },
      // 我的工具任务
      {
        path: 'tool-task',
        name: 'ToolTask',
        component: () => import('@/views/projectCenter/toolTask/index.vue'),
        meta: {
          title: '项目中心 - 我的工具任务',
          keepAlive: false,
        }
      },
      // 我的收藏
      {
        path: 'my-favorite',
        name: 'MyFavorite',
        component: () => import('@/views/projectCenter/myFavorite/index.vue'),
        meta: {
          title: '项目中心 - 我的收藏',
          keepAlive: false,
        }
      },
      {
        path: 'data',
        name: 'MyData',
        component: Root,
        meta: {
          title: '我的数据',
          keepAlive: false
        },
        children: [
          // {
          //   path: 'project-data',
          //   name: 'ProjectData',
          //   component: () => import('@/views/projectCenter/data/project/iframe.vue'),
          //   meta: {
          //     title: '项目中心 - 项目数据',
          //     keepAlive: false
          //   }
          // },
          {
            path: 'project-data',
            name: 'ProjectData',
            component: () => import('@/views/projectCenter/data/project/index.vue'),
            meta: {
              title: '项目中心 - 项目数据',
              keepAlive: false
            }
          },
          {
            path: 'origin',
            name: 'OriginData',
            component: () => import('@/views/projectCenter/data/origin/index.vue'),
            meta: {
              title: '项目中心 - 原始数据',
              keepAlive: false
            }
          },
          // {
          //   path: 'tool-data',
          //   name: 'ToolDataIframe',
          //   component: () => import('@/views/projectCenter/data/tool/iframe.vue'),
          //   meta: {
          //     title: '项目中心 - 工具数据',
          //     keepAlive: false
          //   }
          // },
          {
            path: 'tool-data',
            name: 'ToolData',
            component: () => import('@/views/projectCenter/data/tool/index.vue'),
            meta: {
              title: '项目中心 - 工具数据',
              keepAlive: false
            }
          },
          {
            path: 'cmd-doc',
            name: 'CmdDoc',
            component: () => import('@/views/projectCenter/data/origin/cmdDoc.vue'),
            meta: {
              title: '项目中心 - 命令行工具使用手册',
              keepAlive: false
            }
          }
        ],
      },
      // FAQ页面
      {
        path: 'question',
        name: 'Question',
        component: () => import('@/views/projectCenter/common/question.vue'),
        meta: {
          title: '美吉网盘常见问题',
          keepAlive: false,
          siderBar: false
        }
      },
      // 403页面
      {
        path: '/403',
        name: '403',
        component: () => import('@/views/projectCenter/common/403.vue'),
        meta: {
          title: '暂无权限',
        }
      },
      // 404页面
      {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import('@/views/projectCenter/common/notFound.vue'),
        meta: {
          title: '页面未找到',
        }
      }
    ],
     
  },
  
]

const router = createRouter({
  history: createWebHistory(''),
  routes
})

export default router
